import React, { useRef, useState } from "react";
import { useNavigate } from "react-router-dom";

/** Utilities */
import { removeCookie } from "../../utils/Cookies/CookieHandler";

/** Common Components */
import Image from "../../components/image/Image";
import Buttons from "../../components/ui/button/Buttons";
import FormCreator from "../../components/finalForms/FormCreator";

/** Common Services & Data Files */
import { AppIcons } from "../../data/appIcons";
import SwalAlert from "../../services/swalService/SwalService";
import ToastService from "../../services/toastService/ToastService";

/** Configuration Files */
import forgotPasswordField from "./forgotPassword.formfield.config";

/** RTK Query */
import { useForgotPasswordMutation } from "../../app/services/authAPI";

/** CSS Files */
import "../forgotPassword/ForgotPassword.scss";

const ForgotPassword = () => {
  const forgotPasswordRef = useRef();
  const [passwordForm] = useState(forgotPasswordField);

  const navigate = useNavigate();
  const { error } = SwalAlert();

  const [sendEmail, { isLoading: isSendingEmail }] = useForgotPasswordMutation();
  const requestPending = useRef(false);

  const handleClick = async () => {
    if (requestPending.current || isSendingEmail) return;
    const formData = forgotPasswordRef.current?.getFormData();
    if (!formData) return;
    const email = formData.emailAddress?.trim();
    if (!email) return;

    requestPending.current = true;
    try {
      const result = await sendEmail({ EmailAddress: email }).unwrap();
      if (!(result?.keyValue > 0)) {
        error(result?.errorMessage || "Reset email could not be sent. Please try again.", "Error!");
        return;
      }
      ToastService.success(result.errorMessage || "Reset password link has been sent to your email!");
      removeCookie("rememberMe");
      navigate("/login", { state: email });
    } catch {
      error("Reset email could not be sent. Please try again.", "Error!");
    } finally {
      requestPending.current = false;
    }
  };

  return (
    <div className="login-main-section">
      <div className="login-container">
        <div className="login-content">
          <div className="login-background">
            <Image imagePath={AppIcons.LoginImg} altText="Login Vector" />
          </div>
          <div className="login-form-sec">
            <div className="center-form-section">
              <h1 className="logo-img">
                <Image
                  imagePath={AppIcons.logoImage}
                  altText="Login Vector"
                />
              </h1>
              <div className="login-form-desc">
                <div className="card-title-main">Forgot Password</div>
              </div>
              <div className="login-form-part">
                <FormCreator
                  ref={forgotPasswordRef}
                  config={passwordForm}
                />
              </div>
              <Buttons
                buttonText={"Send Email"}
                buttonTypeClassName="btn theme-btn w-full"
                onClick={handleClick}
                isLoading={isSendingEmail}
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ForgotPassword;
